var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}),_c('h1',[_vm._v(_vm._s(_vm.head))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.message))]),_c('button',{on:{"click":_vm.closePage}},[_vm._v("我知道了")])])}
var staticRenderFns = []

export { render, staticRenderFns }